import { render, staticRenderFns } from "./AppCollapseItem.vue?vue&type=template&id=de76bc2a&"
import script from "./AppCollapseItem.vue?vue&type=script&lang=js&"
export * from "./AppCollapseItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de76bc2a')) {
      api.createRecord('de76bc2a', component.options)
    } else {
      api.reload('de76bc2a', component.options)
    }
    module.hot.accept("./AppCollapseItem.vue?vue&type=template&id=de76bc2a&", function () {
      api.rerender('de76bc2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/@core/components/app-collapse/AppCollapseItem.vue"
export default component.exports